import { projectsDataStore } from "./../../../Stores/ProjectsStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { API } from "General/API";
import { OxModuleType } from "Pages/Project/OxIntegration/subMenuConfig";
import { OXSYNC_getOXSyncToken } from "General/APIQueryParams";

class OXConfigStore extends CoreStore {
  oXSetupComplete: boolean = null;
  oXAdminSettings: API_OXSystemSettings = null;

  constructor() {
    super();

    makeObservable(this, {
      oXSetupComplete: observable,
      oXAdminSettings: observable,
      clear: action.bound,
      fetchOxAdminStatus: action.bound,
      fetchOxSettingsStatus: action.bound,
      updateOxAdminSettings: action.bound,
      generateOxSyncToken: action.bound,
    });
  }

  url() {
    return API_URL.OX.getOXSettings();
  }

  clear() {
    this.oXSetupComplete = null;
    this.oXAdminSettings = null;
  }

  @handleStoreState()
  async fetchOxAdminStatus() {
    try {
      const response: API_OXSystemSettings = await API.getData(this.url());
      runInAction(() => {
        if (response) {
          this.oXAdminSettings = response;
          this.oXSetupComplete = response?.configuredCompletely;
        }
      });
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async fetchOxSettingsStatus(module: OxModuleType) {
    try {
      const response = await API.getData<API_BooleanData>(
        API_URL.OX.getOxConfigurationStatus(projectsDataStore.projectId),
        { module }
      );
      return response.booleanValue;
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async updateOxAdminSettings(body: API_OXSystemSettings) {
    try {
      await API.editData(this.url(), body);
    } catch (error) {
      throw error;
    }
  }

  async generateOxSyncToken(params: OXSYNC_getOXSyncToken) {
    try {
      const response: API_StringData = await API.getData(API_URL.OXSYNC.getOXSyncToken(), params);
      return response.stringValue;
    } catch (error) {
      throw error;
    }
  }
}

export const oXConfigStore = new OXConfigStore();
